import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("vvm_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
